module.exports = "<div id=\"left-panel\" class=\"stores-leftPanel\" tabindex=\"-1\" ui-view=\"left-panel\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/stores/views/stores-left-panel.view.html
// module id = 1145
// module chunks = 0